export default "__VITE_ASSET__D1AgUS$O__"